import {
	isStoreHuman,
	type StoreChatItem,
	type StoreHuman,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { findLast } from './findLast';

export const getLastHumanMessageFromConversation = (
	messages: StoreChatItem[],
): StoreHuman | undefined => {
	return findLast(messages, isStoreHuman) as StoreHuman | undefined;
};
